import { render, staticRenderFns } from "./RecipesCoating_ProductItem.vue?vue&type=template&id=5b311249"
import script from "./RecipesCoating_ProductItem.vue?vue&type=script&lang=js"
export * from "./RecipesCoating_ProductItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports